export default "__VITE_ASSET__674aafb7__"